export default "__VITE_ASSET__VB76hwgY__"